const metadataLine = /^\s*\[[^\]]+\]\s*$/;
const titleSuffix = /\s*\|\|\s*$/;

export const getSearchResultDetails = result => {
  const pathParts = (result.fileName || '').split('/').filter(Boolean);
  const fileName = pathParts.pop() || '';
  const lines = (result.content || '').split(/\r?\n/).map(line => line.trim()).filter(Boolean);
  const titleLine = lines.find(line => titleSuffix.test(line));
  const title = result.title || titleLine?.replace(titleSuffix, '') || fileName.replace(/\.txt$/i, '');
  const lyrics = lines.filter(line => !metadataLine.test(line) && !titleSuffix.test(line));

  return {
    folders: pathParts,
    fileName: fileName.replace(/\.txt$/i, ''),
    title,
    snippet: lyrics.slice(0, 2).join(' ').replace(/\s+/g, ' ').trim()
  };
};
